<script>
import { mapState } from 'vuex';
import { forEach, size } from 'lodash-es';
import { showModal } from '@phoenix/helpers/modal-helper';

export default {
  props: {
    storeSelectorModalId: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    boutiqueAppointmentUrl: {
      type: String,
      required: true,
    },
    btnClasses: {
      type: [Array, String],
      default: () => [],
    },
    dataAttributes: {
      type: Array,
      default: () => [],
    },
    displayInline: {
      type: Boolean,
      default: false,
    },
    productReference: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      selectedStore: null,
      isLoading: false,
      error: null,
    };
  },

  computed: {
    ...mapState('storeSelector', ['storePageId']),

    classes() {
      return Array.isArray(this.btnClasses) ? this.btnClasses.join(' ') : this.btnClasses;
    },

    tag() {
      return this.displayInline ? 'a' : 'button';
    },

    href() {
      return this.displayInline ? this.target : false;
    },

    target() {
      return `#${this.storeSelectorModalId}`;
    },
  },

  watch: {
    storePageId(storePageId) {
      if (storePageId) {
        this.updateStore(storePageId);
      }
    },
  },

  mounted() {
    if (size(this.dataAttributes) > 0) {
      forEach(this.dataAttributes, (attr) => {
        this.$el.setAttribute(attr.name, attr.value);
      });
    }
  },

  methods: {
    updateStore(storePageId) {
      if (!storePageId) {
        return;
      }

      const boutiqueAppointmentUrl = new URL(this.boutiqueAppointmentUrl);
      boutiqueAppointmentUrl.searchParams.set('page_id', storePageId);
      window.location.href = boutiqueAppointmentUrl.href;
    },

    showModal,
  },
};
</script>

<template>
  <component :is="tag" :href="href" :class="classes" @click="showModal(storeSelectorModalId)">
    <slot />{{ text }}
  </component>
</template>
